module.exports = __webpack_public_path__ + "static/media/0024_IMG_FE_LES_MURS_PALOMINO_W_VPL2100_VERTICALE.4321dd8b.png";